/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavPlatform
 */
export interface OutputUavPlatform {
    /**
     * 
     * @type {number}
     * @memberof OutputUavPlatform
     */
    freqControlMaxMhz?: number;
    /**
     * Частоти — діапазон: *Mhz нижня межа, *MaxMhz верхня (null = одна частота).
     * @type {number}
     * @memberof OutputUavPlatform
     */
    freqControlMhz?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavPlatform
     */
    freqVideoMaxMhz?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavPlatform
     */
    freqVideoMhz?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavPlatform
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavPlatform
     */
    maxDurationMin?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavPlatform
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavPlatform
     */
    speedKmh?: number;
    /**
     * Type — recon | bomber | kamikaze.
     * @type {string}
     * @memberof OutputUavPlatform
     */
    type?: string;
}

/**
 * Check if a given object implements the OutputUavPlatform interface.
 */
export function instanceOfOutputUavPlatform(value: object): boolean {
    return true;
}

export function OutputUavPlatformFromJSON(json: any): OutputUavPlatform {
    return OutputUavPlatformFromJSONTyped(json, false);
}

export function OutputUavPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavPlatform {
    if (json == null) {
        return json;
    }
    return {
        
        'freqControlMaxMhz': json['freqControlMaxMhz'] == null ? undefined : json['freqControlMaxMhz'],
        'freqControlMhz': json['freqControlMhz'] == null ? undefined : json['freqControlMhz'],
        'freqVideoMaxMhz': json['freqVideoMaxMhz'] == null ? undefined : json['freqVideoMaxMhz'],
        'freqVideoMhz': json['freqVideoMhz'] == null ? undefined : json['freqVideoMhz'],
        'id': json['id'] == null ? undefined : json['id'],
        'maxDurationMin': json['maxDurationMin'] == null ? undefined : json['maxDurationMin'],
        'name': json['name'] == null ? undefined : json['name'],
        'speedKmh': json['speedKmh'] == null ? undefined : json['speedKmh'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function OutputUavPlatformToJSON(value?: OutputUavPlatform | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'freqControlMaxMhz': value['freqControlMaxMhz'],
        'freqControlMhz': value['freqControlMhz'],
        'freqVideoMaxMhz': value['freqVideoMaxMhz'],
        'freqVideoMhz': value['freqVideoMhz'],
        'id': value['id'],
        'maxDurationMin': value['maxDurationMin'],
        'name': value['name'],
        'speedKmh': value['speedKmh'],
        'type': value['type'],
    };
}

